// extracted by mini-css-extract-plugin
export default {"maxHeight":"maxHeight--abo2B"};